import { Stack } from "@mui/material";
import { Text, Title } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

export function RegularTimeDisplay(props: { timeWorked: string; timeLeft: string }) {
  const { timeWorked, timeLeft } = props;
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      gap={isRebrandingEnabled() ? 1 : 4}
      sx={{ width: "100%", ...(isRebrandingEnabled() && { marginTop: -6 }) }}
    >
      <Title
        component="h2"
        variant="h2"
        sx={{
          textAlign: "center",
          ...(isRebrandingEnabled() && {
            // Force body-font here because the serif font looks terrible with tabular-nums
            // It's important to have tabular-nums since this is ticking up and there's movement otherwise
            fontFamily: "Lato, sans-serif",
            fontVariantNumeric: "tabular-nums",
            fontWeight: 600,
          }),
        }}
      >
        {timeWorked}
      </Title>
      <Text variant="body1" sx={{ textAlign: "center" }}>
        {timeLeft}
      </Text>
    </Stack>
  );
}
